import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function ClosingSection() {
  return <section className="w-full bg-[#0b0b0b] py-24 md:py-40 px-4 relative overflow-hidden border-t border-white/5" data-id="element-44">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#e53935]/20 via-transparent to-transparent pointer-events-none" data-id="element-45"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-46">
        <h2 className="text-3xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-8 md:mb-12" data-id="element-47">
          Si querés mejorar de verdad,{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#e53935] to-[#ef5350]" data-id="element-48">
            este es el momento
          </span>
        </h2>

        <p className="text-gray-400 text-lg md:text-2xl font-medium max-w-2xl mx-auto mb-10 md:mb-16 leading-relaxed" data-id="element-49">
          No dejes que pase otro mes cortando con dudas. Empezá hoy y transformá
          tu forma de trabajar para siempre.
        </p>

        <div className="flex flex-col items-center gap-6" data-id="element-50">
          <a href="#pricing" className="cta-primary inline-flex items-center justify-center gap-2 w-full md:w-auto px-8 md:px-16 py-5 md:py-6 rounded-xl md:rounded-2xl text-white font-black text-base md:text-2xl uppercase tracking-wide shadow-[0_0_50px_rgba(229,57,53,0.4)]" data-id="element-51">
            QUIERO EMPEZAR HOY
            <ChevronRightIcon className="w-6 h-6 md:w-8 md:h-8" data-id="element-52" />
          </a>

          <p className="text-gray-500 text-xs md:text-sm font-semibold uppercase tracking-widest" data-id="element-53">
            Acceso inmediato al material
          </p>
        </div>
      </div>
    </section>;
}